import { cache } from 'react';
import { TagsFragment, getTagsQuery } from './TagsQuery.generated';
import isLoggedIn from '@/server/helpers/isLoggedIn';

const getTags = cache(async () => {
  if (!(await isLoggedIn())) {
    return {} as TagsFragment;
  }
  const { data } = await getTagsQuery({});
  const tags = data?.features ?? {};
  return tags as TagsFragment;
});

export default getTags;
